// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__AhrUM","tab":"ProcedureTabs_tab__2WeOR"};